import * as Yup from 'yup';
import { TIMEZONE_VN } from 'constant';

const createProgramValidationSchema = Yup.object().shape({
  name: Yup.string()
    .max(80, () => 'program.validationErrors.programNameAtMost80Character')
    .required('program.validationErrors.nameRequired'),
  description: Yup.string().required('program.validationErrors.descriptionRequired'),
  startingTime: Yup.string()
    .test({
      name: 'endingTime',
      exclusive: false,
      params: {},
      message: 'program.validationErrors.startingTimeBeforeEndingTimeRequired',
      test: (value, context) => {
        const { endingTime } = context.parent;
        if (!endingTime) return true;

        const endingTimeDate = new Date(endingTime).toLocaleDateString('en-ZA', {
          timeZone: TIMEZONE_VN,
        });
        const startingTimeDate = new Date(value).toLocaleDateString('en-ZA', {
          timeZone: TIMEZONE_VN,
        });
        return startingTimeDate < endingTimeDate;
      },
    })
    .required('program.validationErrors.startingTimeRequired')
    .nullable(),
  endingTime: Yup.string()
    .test({
      name: 'startingTime',
      exclusive: false,
      params: {},
      message: 'program.validationErrors.endingTimeAfterStartingTimeRequired',
      test: (value, context) => {
        const { startingTime } = context.parent;
        if (!startingTime) return true;

        const startingTimeDate = new Date(startingTime).toLocaleDateString('en-ZA', {
          timeZone: TIMEZONE_VN,
        });
        const endingTimeDate = new Date(value).toLocaleDateString('en-ZA', {
          timeZone: TIMEZONE_VN,
        });
        return startingTimeDate < endingTimeDate;
      },
    })
    .required('program.validationErrors.endingTimeRequired')
    .nullable(),
});

export default createProgramValidationSchema;
